import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import "core-js/features/array/from";
import "core-js/features/array/flat";
import "core-js/features/array/flat-map";
import "core-js/features/array/find";
import "core-js/features/array/find-index";
import "core-js/features/array/fill";
import "core-js/features/array/includes";
import "core-js/features/object/values";
import "core-js/features/object/assign";
import "core-js/features/string/includes";
import "core-js/features/promise";
import "utils/polyfills";
import { MatomoProvider } from "@datapunt/matomo-tracker-react";
import { ThemeProvider } from "styled-components";
import { HealthcheckContextProvider } from "@webapi/contexts/healthcheck";
import { OrganizationsContextProvider } from "@webapi/contexts/organizations";
import { MeasuresContextProvider } from "@webapi/contexts/measures";
import { CloudfrontContextProvider } from "@media";
import { NotificationContextProvider } from "@notifications/context";
import { UnitsListsContextProvider } from "@unitLists";
import { AuthContextProvider } from "@authentication/context";
import { theme } from "themes";
import { createMatomoInstance } from "@tracking";
import GlobalStyles from "globalStyles";
import App from "./App";
import "../theme.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});
ReactDOM.render( /*#__PURE__*/_jsxs(BrowserRouter, {
  children: [/*#__PURE__*/_jsx(GlobalStyles, {}), /*#__PURE__*/_jsx(QueryClientProvider, {
    client: queryClient,
    children: /*#__PURE__*/_jsx(AuthContextProvider, {
      children: /*#__PURE__*/_jsx(HealthcheckContextProvider, {
        children: /*#__PURE__*/_jsx(CloudfrontContextProvider, {
          children: /*#__PURE__*/_jsx(NotificationContextProvider, {
            children: /*#__PURE__*/_jsx(MeasuresContextProvider, {
              children: /*#__PURE__*/_jsx(OrganizationsContextProvider, {
                children: /*#__PURE__*/_jsx(UnitsListsContextProvider, {
                  children: /*#__PURE__*/_jsx(ThemeProvider, {
                    theme: theme,
                    children: /*#__PURE__*/_jsx(MatomoProvider, {
                      value: createMatomoInstance(),
                      children: /*#__PURE__*/_jsx(App, {})
                    })
                  })
                })
              })
            })
          })
        })
      })
    })
  })]
}), document.getElementById("vis-wrapper"));